import { useQuery } from '@tanstack/react-query'
import { getData } from '../../apis/api.helpers'
import apiUrl from '../../apis/api.url'
import { useAuthStore } from '../../store/authStore'
import { parseQueryParams } from '../../utilities/parsers'
import { QueryParams } from '../../common/types'

const buildUrlWithParams = (
  baseUrl: string,
  params: Record<string, any> = {}
) => {
  return `${baseUrl}${parseQueryParams(params)}`
}

const fetchDashboardUser = async () => {
  const url = buildUrlWithParams(apiUrl.DASHBOARD_USER)
  const response = await getData(url)
  return response
}

export const useDashboard = () => {
  const authenticated = useAuthStore((state) => state.authenticated)

  return useQuery(
    ['dashboard_listing', authenticated],
    () => {
      if (authenticated) {
        return fetchDashboardUser()
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )
}
const fetchData = async (input: QueryParams) => {
  const url = buildUrlWithParams(apiUrl.DASHBOARD_CERTIFICATE, {
    ...input,
  })
  const response = await getData(url)
  return response
}

export const useFetchCertificate = (input: QueryParams) => {
  return useQuery(['certificate', input], () => fetchData(input), {})
}

const fetchUpcomingPrograms = async () => {
  const url = buildUrlWithParams(apiUrl.TRAININGCALENDAR, {
    status: 'upcoming',
  })
  const response = await getData(url)
  return response
}

export const useUpcomingPrograms = () => {
  return useQuery(['upcoming_programs'], () => fetchUpcomingPrograms(), {
    refetchOnWindowFocus: false,
  })
}
